import { createApp, h } from 'vue'
import { InertiaProgress } from '@inertiajs/progress'
import { createInertiaApp } from '@inertiajs/inertia-vue3'
import SweetAlert2 from './plugins/sweetalert2'
import Toast from './Shared/Toast'

InertiaProgress.init()

createInertiaApp({
  resolve: name => require(`./Pages/${name}`),
  title: title => title ? `${title} - Realgestion` : 'RealGestion',
  setup({ el, App, props, plugin }) {
    const app = createApp({ render: () => h(App, props) })
    app.use(plugin)
    app.use(SweetAlert2)
    app.config.globalProperties.$toast = Toast
    app.mount(el)
  },
})
